"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BasePlugin = /** @class */ (function () {
    function BasePlugin(configs) {
        this.type = 'base';
        this.offsetByte = undefined;
        this.triggerHandler = function (data) {
            // mute
        };
        this.delegateReporter = false;
        this.configs = configs !== null && configs !== void 0 ? configs : {};
    }
    BasePlugin.prototype.serverNow = function (timestamp) {
        return new Date().getTime();
    };
    // remote config
    BasePlugin.prototype.register = function (props) {
        // 
        this.triggerHandler = props.trigger;
    };
    BasePlugin.prototype.unregister = function (app_name) {
        this.triggerHandler = function () {
            //
        };
    };
    // 更新配置
    BasePlugin.prototype.updateConfig = function (newConfigs) {
        this.configs = Object.assign(this.configs, newConfigs);
    };
    /** set key-value labels in all report data */
    BasePlugin.prototype.addLabels = function (labels) {
        //
    };
    return BasePlugin;
}());
exports.default = BasePlugin;
